module.exports = require('./helpers/bundle-url').getBundleURL('ksUvU') + "popup_banner.78a9d0ab.jpeg" + "?" + Date.now();